var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { query } from 'lit/decorators.js';
import { withResizeObserver } from '../../internal/with-resize-observer';
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import styles from './NavBar.styles';
export class SgdfNavBar extends withResizeObserver(LitElement) {
    onResize({ width }) {
        this._width = width;
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete.then(() => {
            this.drawer.addEventListener('click', () => this.drawer.hide());
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    render() {
        const bigMode = this._width && this._width > 700;
        return html `
            <sl-drawer class="drawer-menu" label="Menu" placement="start">
                ${bigMode ? null : html `<slot></slot>`}
            </sl-drawer>

            ${bigMode ? this._renderBig() : this._renderSmall()}
        `;
    }
    _renderBig() {
        return html `
            <nav class="sgdf-navbar" part="navbar" role="navigation">
                <div class="sgdf-navbar-links">
                    <slot></slot>
                </div>
                <div class="nav-item-mobile" part="end">
                    <slot name="end"></slot>
                </div>
            </nav>
        `;
    }
    _renderSmall() {
        return html `
            <div class="sgdf-navbar-mobile sticky">
                <div class="nav-item-mobile clickable">
                    <sgdf-icon
                        @click=${() => this.drawer.show()}
                        name="bars"
                        style="--icon-size: 1.5em;"
                    ></sgdf-icon>
                </div>
                <div class="nav-item-mobile" part="center">
                    <slot name="center"></slot>
                </div>
                <div class="nav-item-mobile" part="end">
                    <slot name="end"></slot>
                </div>
            </div>
        `;
    }
}
SgdfNavBar.styles = styles;
__decorate([
    query('.drawer-menu')
], SgdfNavBar.prototype, "drawer", void 0);
__decorate([
    query('.menu')
], SgdfNavBar.prototype, "menu", void 0);
//# sourceMappingURL=NavBar.js.map